// Packages
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
// Redux
import { clearReducer } from '../auth/authThunk';

export type TStatusList = 'client' | 'job' | 'candidate';

/**
 * A status is created or deleted inside a modal (company, job, candidate), while the list page's
 * status filter keeps its own options loaded on mount. The revision tells every mounted filter
 * that its options are stale, so it reloads them without a page refresh.
 */
interface ISliceStatusListsState {
  revisions: Record<TStatusList, number>;
}

const initialState: ISliceStatusListsState = {
  revisions: { client: 0, job: 0, candidate: 0 },
};

const statusListsSlice = createSlice({
  name: 'statusLists',
  initialState,
  reducers: {
    statusListChanged: (state, { payload }: PayloadAction<TStatusList>) => {
      state.revisions[payload] += 1;
    },
  },
  extraReducers: builder => {
    //* CLEAR REDUCER AFTER SIGN OUT
    builder.addCase(clearReducer, () => initialState);
  },
});

export default statusListsSlice;

export const { statusListChanged } = statusListsSlice.actions;
